import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export const Confirmation = ({ firstName }) => (
  <motion.div className="confirmation" data-testid="confirmation-screen"
    initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease }}>
    <motion.div className="confirm-ring" initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.15, ease }}>
      <svg width="34" height="34" fill="none" viewBox="0 0 34 34" aria-hidden="true">
        <circle cx="17" cy="17" r="16" stroke="#3aaa6e" strokeWidth="1.4" />
        <motion.path d="M10 17.5l5 5 10-10" stroke="#3aaa6e" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
          initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.7, delay: 0.5 }} />
      </svg>
    </motion.div>
    <h2>Application Received</h2>
    <p>Thank you for applying to the Pay It Forward program. We have your information and will review it right now.</p>
    {firstName && <p data-testid="confirmation-personal-line">{firstName}, keep your phone nearby — we will be in touch shortly.</p>}
    <div className="confirm-pill" data-testid="confirmation-pill">
      <svg width="16" height="16" fill="none" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="7" stroke="var(--gold)" strokeWidth="1.2" /><path d="M8 5v4l2.5 2" stroke="var(--gold)" strokeWidth="1.2" strokeLinecap="round" /></svg>
      Expect a personal call within the hour.
    </div>
  </motion.div>
);
